import { Component, OnInit } from '@angular/core';
import { Globals } from '../globals';
declare function info_noti(msg:any):any;
@Component({
  selector: 'app-sharehealthcard',
  templateUrl: './sharehealthcard.component.html',
  styleUrls: ['./sharehealthcard.component.css']
})
export class SharehealthcardComponent implements OnInit {

  constructor(private global:Globals) { }
healthCard;
  ngOnInit() {

    this.healthCard=this.global.sharehealthCard;
  }

}
